import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LayoutService {
	private readonly STORAGE_KEY = 'useNewLayout';
	private isNewLayoutSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	isNewLayout$ = this.isNewLayoutSubject.asObservable();

	constructor() {
		const storedValue = localStorage.getItem(this.STORAGE_KEY);
		this.isNewLayoutSubject.next(storedValue === 'true');
	}

	getCurrentLayoutState(): boolean {
		return this.isNewLayoutSubject.getValue();
	}

	// Toggle layout and persist in localStorage
	toggleLayout(): void {
		const newValue = !this.isNewLayoutSubject.getValue();
		this.isNewLayoutSubject.next(newValue);
		localStorage.setItem(this.STORAGE_KEY, newValue.toString());
	}
}
